/**
 * Set webpack's asset base from the page-loaded runtime configuration.
 *
 * @param {string} productionPath CDN-relative production path.
 * @param {string} developmentPath CDN-relative development-server path.
 */
export function setRuntimePublicPath(productionPath, developmentPath = productionPath) {
  const runtimeConfig = window.__MAGNETIQ_RUNTIME_CONFIG__;
  if (!runtimeConfig || !runtimeConfig.cdnOrigin) {
    throw new Error('Frontend runtime configuration was not loaded before the bundle');
  }

  const path = runtimeConfig.environment === 'development'
    ? developmentPath
    : productionPath;
  __webpack_public_path__ = `${runtimeConfig.cdnOrigin}${path}`;
}
